import { CaseAssetViewStats } from './calculateAssetViewStats';

export default function calculateAssetOpenRate(caseAssetViewStats: CaseAssetViewStats) {
  return caseAssetViewStats.avgOpenRate.cappedAssetOpenRate;
}
